import { useCallback } from 'react';
import { create } from 'zustand';

import { axiosInstanceV3 } from '@mais-retorno-front/configs/axios-config';

interface IUseStore {
  data: IFundPolicies;
  loading: boolean;
  setLoading: (isLoading: boolean) => void;
  setData: (stats: IFundPolicies) => void;
}

const useStore = create<IUseStore>((set) => ({
  data: null,
  loading: true,
  setLoading: (isLoading: boolean) => set({ loading: isLoading }),
  setData: (data: IFundPolicies) => set({ data }),
}));

export const useSheetFundPolicies = () => {
  const fundPolicy = useStore((state) => state.data);
  const loading = useStore((state) => state.loading);
  const setLoading = useStore((state) => state.setLoading);
  const setData = useStore((state) => state.setData);

  const getFundPolicy = useCallback(
    async (fundSlug: string) => {
      setLoading(true);

      try {
        const { data: stats } = await axiosInstanceV3.get<IResponse>(
          `/funds/policies/${fundSlug}`
        );

        if (stats) {
          setData({
            ...stats,
            administration_fee: {
              ...stats.administration_fee,
              isMoney:
                stats.administration_fee.max >= 100 ||
                stats.administration_fee.min >= 100,
            },
          });
        }
      } catch (error) {
        setData(null);
      }

      setLoading(false);
    },
    [setData, setLoading]
  );

  return {
    loadingPolicies: loading,
    fundPolicy,
    getFundPolicy,
  };
};

interface IResponse {
  fund: {
    nicename: string;
    cnpj: number;
  };
  target_group: string;
  objective: null;
  investment_policy: string;
  administration_fee: {
    min: number;
    max: number;
  };
  minimum_application_value: number;
  fund_perfomance_fee: {
    fee: string;
    exists: boolean;
    index_reference: string;
    desc_performance_fee: string;
  };
  days_for_quote_redemption: string;
  days_for_money_redemption: string;
  permanency_minimum_amount: number;
  bought_quote_conversion_period: number;
  bought_quote_conversion_type: any;
  cancelation_quotation_type: any;
}

export interface IFundPolicies extends IResponse {
  administration_fee: {
    min: number;
    max: number;
    isMoney: boolean;
  };
}
